import React from 'react';

const Point = ({match}) => {
  console.log(match);
  return <div>적립금 설정</div>;
};

export default Point;
